/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyBalanceTransactionKey,
  ShopifyBalanceTransactionToOrderKey,
  ShopifyBalanceTransactionToOrderTransactionKey,
  ShopifyBalanceTransactionToPayoutKey,
  ShopifyBalanceTransactionToShopKey,
  ShopifyOrderKey,
  ShopifyOrderTransactionKey,
  ShopifyPayoutKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion, ShopifyApiVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyBalanceTransactionKey,
  "2022-01": {
    name: "Shopify Balance Transaction",
    fields: [
      {
        name: "Amount",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "amount" },
        },
      },
      {
        name: "Currency",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "currency" },
        },
      },
      {
        name: "Fee",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "fee" },
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "id" },
        },
      },
      {
        name: "Net",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "net" },
        },
      },
      {
        name: "Payout",
        fieldType: FieldType.BelongsTo,
        key: ShopifyBalanceTransactionToPayoutKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "payout_id" },
        },
        configuration: {
          relatedModelKey: ShopifyPayoutKey,
        },
      },
      {
        name: "Payout Status",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "payout_status" },
        },
      },
      {
        name: "Processed At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "processed_at" },
        },
      },
      {
        name: "Source ID",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "source_id" },
        },
      },
      {
        name: "Source Type",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "source_type" },
        },
      },
      {
        name: "Source Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyBalanceTransactionToOrderKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "source_order_id",
          },
        },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Source Order Transaction",
        fieldType: FieldType.BelongsTo,
        key: ShopifyBalanceTransactionToOrderTransactionKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "source_order_transaction_id",
          },
        },
        configuration: {
          relatedModelKey: ShopifyOrderTransactionKey,
        },
      },
      {
        name: "Test",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "test" },
        },
      },
      {
        name: "Type",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "type" },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyBalanceTransactionToShopKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" },
        },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "balance", syncFunction: "transactions" },
  },
  "2024-01": {
    fields: [
      {
        name: "Adjustment Order Transactions",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "adjustment_order_transactions" },
        },
      },
    ],
  },
  "2024-07": {
    fields: [
      {
        name: "Adjustment Reason",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "adjustment_reason" },
        },
      },
    ],
  },
};

export const ShopifyBalanceTransaction = ({ apiVersion }: { apiVersion: ShopifyApiVersion }) => buildConnectionSpec(specs, apiVersion);
